import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { ToastContainer, toast, Slide } from 'react-toastify';

class ToastHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldErr: this.props.errors,
      oldSucc: this.props.success,
    };
    this.isNew = this.isNew.bind(this);
    this.errHandle = this.errHandle.bind(this);
    this.succHandle = this.succHandle.bind(this);
  }

  componentDidUpdate() {
    this.isNew();
  }

  isNew() {
    const { errors, success } = this.props;
    const { oldErr, oldSucc } = this.state;
    if (errors !== oldErr) {
      this.setState({
        oldErr: errors,
      });
      this.errHandle(errors);
    }
    if (success !== oldSucc) {
      this.setState({
        oldSucc: success,
      });
      this.succHandle(success);
    }
  }

  errHandle(errors) {
    let errObj;
    if (errors && errors.errors && errors.errors.some(a => typeof a == 'object')) {
      errObj = true;
    }

    let singleError;
    if (errors && errors.error) {
      singleError = errors.error;
    }
    if (singleError) {
      return toast.error(
        <div>
          <div className="toast-icon">
            <img alt="error" src={ process.env.REACT_APP_CDN + '/assets/icons/alert-w.svg'} />
          </div>
          <div className="toast-info">
            {singleError}
          </div>
        </div>
      );
    }

    const errorLoop = errors && errors.errors && errors.errors.map((error, index) => {
      if (errObj) {
        if (error.param) {
          return toast.error(
            <div>
              <div className="toast-icon">
                <img alt="error" src={ process.env.REACT_APP_CDN + '/assets/icons/alert-w.svg'} />
              </div>
              <div className="toast-info">
                {error.value ? (
                  error.msg + ': ' + error.param + ' "' + error.value + '"'
                ) : (
                  error.msg + ': ' + error.param
                )}
              </div>
            </div>
          );
        }
        if (!error.param) {
          return toast.error(
            <div>
              <div className="toast-icon">
                <img alt="error" src={ process.env.REACT_APP_CDN + '/assets/icons/alert-w.svg'} />
              </div>
              <div className="toast-info">
                {error.msg}
              </div>
            </div>
          );
        }
      }
      if (!errObj) {
        if (error === 'File too large') {
          return toast.error(
            <div>
              <div className="toast-icon">
                <img alt="error" src={ process.env.REACT_APP_CDN + '/assets/icons/alert-w.svg'} />
              </div>
              <div className="toast-info">
                Images must be less than 4MB
              </div>
            </div>
          );
        }
        return toast.error(
          <div>
            <div className="toast-icon">
              <img alt="error" src={ process.env.REACT_APP_CDN + '/assets/icons/alert-w.svg'} />
            </div>
            <div className="toast-info">
              {error}
            </div>
          </div>
        );
      }
      return (null);
    });

    if (errorLoop) {
      return errorLoop;
    }
  }

  succHandle(success) {
    let succObj;
    if (success && success.success && success.success.some(a => typeof a == 'object')) {
      succObj = true;
    }
    const successLoop = success && success.success && success.success.map((succ, index) => {
      if (succObj) {
        if (succ.param) {
          return toast.success(
            <div>
              <div className="toast-icon">
                <img alt="success" src={ process.env.REACT_APP_CDN + '/assets/icons/tick.svg'} />
              </div>
              <div className="toast-info">
                {succ.msg + ': ' + succ.param}
              </div>
            </div>
          );
        }
        if (!succ.param) {
          return toast.success(
            <div>
              <div className="toast-icon">
                <img alt="success" src={ process.env.REACT_APP_CDN + '/assets/icons/tick.svg'} />
              </div>
              <div className="toast-info">
                {succ.msg}
              </div>
            </div>
          );
        }
      }
      if (!succObj) {
        return toast.success(
          <div>
            <div className="toast-icon">
              <img alt="success" src={ process.env.REACT_APP_CDN + '/assets/icons/tick.svg'} />
            </div>
            <div className="toast-info">
              {succ}
            </div>
          </div>
        );
      }
      return (null);
    });

    return successLoop;
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <ToastContainer
          position="top-center"
          autoClose={7000}
          closeOnClick={false}
          transition={Slide}
          draggablePercent={40}
          // pauseOnFocusLoss={false}
          hideProgressBar
          className={classes}
        />
      </div>
    );
  }
}

export default withRouter(ToastHandler);
